const BFCACHE_RELOAD_FLAG =
  'tax_referral_form_submitted_pending_bfcache_reload';

function markFormSubmittedForBfcacheReload(): void {
  try {
    sessionStorage.setItem(BFCACHE_RELOAD_FLAG, 'true');
  } catch {
    // quota exceeded or unavailable in private browsing — fail silently
  }
}

function consumeFormSubmittedForBfcacheReloadFlag(): boolean {
  try {
    const wasSet = sessionStorage.getItem(BFCACHE_RELOAD_FLAG) === 'true';
    if (wasSet) {
      sessionStorage.removeItem(BFCACHE_RELOAD_FLAG);
    }
    return wasSet;
  } catch {
    return false;
  }
}

export {
  markFormSubmittedForBfcacheReload,
  consumeFormSubmittedForBfcacheReloadFlag
};
